import PrivacyPolicy4 from './PrivacyPolicy4'
export default PrivacyPolicy4
